import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, BellRing, Check } from "lucide-react";

const when = (iso) => new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export default function CheckinAlerts() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = useCallback(() => api.get("/portal-admin/alerts").then((r) => setItems(r.data || [])).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const review = async (id) => {
    try { await api.post(`/portal-admin/checkins/${id}/review`); setItems((xs) => xs.filter((x) => x.id !== id)); }
    catch { toast.error("Could not mark reviewed — retry"); }
  };
  if (!items.length) return null;
  return (
    <div className="mt-6 rounded-2xl border border-amber-200 bg-amber-50/60 p-5" data-testid="checkin-alerts">
      <div className="mb-3 flex items-center gap-2 font-heading text-sm font-bold text-amber-900"><BellRing className="h-4 w-4" /> Patient check-ins with a pain change ({items.length})</div>
      <ul className="space-y-2">
        {items.map((c) => (
          <li key={c.id} className="flex flex-wrap items-center gap-3 rounded-xl bg-white p-3 text-sm" data-testid={`checkin-alert-${c.id}`}>
            <button onClick={() => navigate(`/patients/${c.cliniko_id}`)} data-testid={`checkin-alert-patient-${c.id}`} className="font-semibold text-slate-900 hover:underline">{c.patient_name}</button>
            <span className={`inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 text-xs font-bold ${c.change > 0 ? "bg-red-100 text-red-700" : "bg-emerald-100 text-emerald-700"}`}>
              {c.change > 0 ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />} {c.pain - c.change} → {c.pain}
            </span>
            <span className="min-w-0 flex-1 truncate text-slate-600">{c.comment}</span>
            <span className="text-[11px] text-slate-400">{when(c.created_at)}</span>
            <Button size="sm" variant="outline" onClick={() => review(c.id)} data-testid={`checkin-review-${c.id}`}><Check className="mr-1 h-3.5 w-3.5" /> Reviewed</Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
